/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Group_Getting_StartedInputs */

const en_faq_group_getting_started = /** @type {(inputs: Faq_Group_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting started`)
};

const lv_faq_group_getting_started = /** @type {(inputs: Faq_Group_Getting_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā sākt`)
};

/**
* | output |
* | --- |
* | "Getting started" |
*
* @param {Faq_Group_Getting_StartedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_group_getting_started = /** @type {((inputs?: Faq_Group_Getting_StartedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Group_Getting_StartedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_group_getting_started(inputs)
	return en_faq_group_getting_started(inputs)
});